import Client, {
  type BaseURL,
  Environment,
  Local,
  PreviewEnv,
} from '@skrym/shared/lib/api-client/encore-client';

import { clientSideEnv } from '@/lib/env/client-side';

let environment: BaseURL = Local;

if (clientSideEnv.NEXT_PUBLIC_VERCEL_ENV === 'production') {
  environment = Environment('gcp-prod');
} else if (clientSideEnv.NEXT_PUBLIC_VERCEL_ENV === 'preview') {
  if (clientSideEnv.NEXT_PUBLIC_VERCEL_GIT_PULL_REQUEST_ID !== undefined) {
    environment = PreviewEnv(clientSideEnv.NEXT_PUBLIC_VERCEL_GIT_PULL_REQUEST_ID);
  } else {
    environment = Environment('demo'); // Fallback
  }
} else if (clientSideEnv.NEXT_PUBLIC_VERCEL_ENV === 'development') {
  environment = Local;
}

/**
 * Client-side API client
 *
 * This client is used to make API requests from the client-side.
 *
 * NOTE: This does not include any authentication, so only public endpoints can be called
 */
export const clientSideApi = new Client(environment, {
  // TODO: Some better way to handle this?
  fetcher: async (input, init) => {
    return fetch(input, {
      ...init,
      cache: 'no-store',
    });
  },
});
